import styled, {css} from "styled-components";

export const RegulationParticipationTicketIdBox = styled.div<{hidden: boolean}>` //TODO - remove the hidden property when we are done with Italy
  ${props => props.hidden && css`display: none`}
`